/**
 * The masthead: leaf mark and wordmark.
 *
 * Drawn on the web, where a page needs to say what it is, and suppressed inside
 * the native shell, where the app already has a name and an icon on the home
 * screen and repeating them would only cost a phone its vertical space.
 */

import type { JSX } from 'react';
import { showMasthead } from '../platform';
import { LeafMark } from './Icons';

export function Masthead(): JSX.Element | null {
  if (!showMasthead()) return null;
  return (
    <header className="masthead">
      <LeafMark />
      <h1>Counterpoint tutor</h1>
    </header>
  );
}
